var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activeProductInfo.frequentlyBoughtTogether
    ? _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "mobile-wrapper w-full mb-3" },
          [
            _c(
              "Swiper",
              {
                ref: "accessorySwiper",
                staticClass: "h-full w-full",
                attrs: { options: _vm.contentOptions },
              },
              _vm._l(
                _vm.activeProductInfo.frequentlyBoughtTogether,
                function (accessory, index) {
                  return _c("SwiperSlide", { key: index }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "mobile-card flex border-blue-default border-1 rounded-lg mb-2 accessory-card overflow-hidden",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "w-full h-full flex flex-col hover:no-underline justify-center items-center",
                            attrs: { href: accessory.productKey },
                          },
                          [
                            _c("div", { staticClass: "text-center" }, [
                              accessory.productName
                                ? _c(
                                    "h6",
                                    {
                                      staticClass:
                                        "text-blue-default text-22 font-semibold mt-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(accessory.productName) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              accessory.productBrief
                                ? _c("p", { staticClass: "text-md" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(accessory.productBrief) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              accessory.productSpecsHeader
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "text-22 font-semibold mt-0",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(accessory.productSpecsHeader) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            accessory.productImages
                              ? _c("img", {
                                  attrs: {
                                    src: accessory.productImages.url,
                                    alt: accessory.productImages.title,
                                    "data-not-lazy": "",
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]
                    ),
                  ])
                }
              ),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bullets" },
              _vm._l(
                _vm.activeProductInfo.frequentlyBoughtTogether,
                function (slide, index) {
                  return _c("span", {
                    key: index,
                    staticClass: "bullet",
                    class: { active: index + 1 === _vm.active },
                    attrs: { tabindex: "0" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return (() => {
                          _vm.goToSlide(index + 1)
                          _vm.touched = false
                        }).apply(null, arguments)
                      },
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return (() => {
                          _vm.goToSlide(index + 1)
                          _vm.touched = false
                        }).apply(null, arguments)
                      },
                    },
                  })
                }
              ),
              0
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "desktop-wrapper column flex flex-wrap w-full mb-3",
            class:
              _vm.activeProductInfo.frequentlyBoughtTogether.length < 3 &&
              "left-overwrite",
          },
          _vm._l(
            _vm.activeProductInfo.frequentlyBoughtTogether,
            function (accessory, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "flex border-blue-default border-1 rounded-lg mb-2 accessory-card overflow-hidden",
                  on: {
                    click: function ($event) {
                      return _vm.handleAccessoryProductClick(accessory)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "w-full h-full flex flex-col hover:no-underline justify-start items-center",
                    },
                    [
                      _c("div", { staticClass: "text-center" }, [
                        accessory.productName
                          ? _c(
                              "h6",
                              {
                                staticClass:
                                  "text-blue-default text-22 font-semibold mt-2",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(accessory.productName) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        accessory.productBrief
                          ? _c("p", { staticClass: "text-sm mb-1" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(accessory.productBrief) +
                                  "\n          "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      accessory.productImages
                        ? _c("img", {
                            attrs: {
                              src: accessory.productImages.url,
                              alt: accessory.productImages.title,
                              "data-not-lazy": "",
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }
          ),
          0
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }